import { InjectionToken } from "@angular/core";

export const RESPONSE_CACHE_SETTINGS_WEBWORKER_FACTORY = new InjectionToken<() => Worker>(
    'response-cache-settings.worker'
);
